import React, {
  useEffect,
} from 'react';

import {
  useSelector,
} from 'react-redux';

import {
  State,
  Namespace,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import config from 'web-config';

import {
  NamespaceLogo,
} from 'web-components';
import {
  Flex,
  Text,
  icons,
} from 'web-styled';
import {
  useMobileDetect,
} from 'web-hooks';
import * as S from './styled';

const getWelcomeText = (namespace: Namespace): string => {
  switch (namespace.symbol) {
    case 'ideafit': {
      return `
        Welcome ${namespace.name} Member! To access the program builder,
        please log in to your ${namespace.name} account from a computer.
      `;
    }
    case 'strongfirst': {
      return 'Welcome StrongFirst member! To access your training app account, please download the StrongFirst app, then log in with your email and password.';
    }
    default:
      return `
        Welcome ${namespace.name} Member! To access your ${namespace.name} account,
        please download the GymCloud mobile app.
        You will log in using your current ${namespace.name} account username and password.
      `;
  }
};

const getAppUrl = (namespace: Namespace): { apple: string, google: string } => {
  switch (namespace.symbol) {
    case 'strongfirst': {
      return {
        apple: 'https://apps.apple.com/us/app/strongfirst/id6451005125',
        google: 'https://play.google.com/store/apps/details?id=com.strongfirst.mobile',
      };
    }

    default:
      return {
        apple: config.mobile.app_store_url,
        google: config.mobile.google_play_url,
      };
  }
};

const mapState = (state: State) => ({
  namespace: getUiState('namespace')(state),
});

type Props = {
  getApp?: boolean,
};

const UseApp = ({ getApp }: Props) => {
  const { namespace } = useSelector(mapState);

  const apps = getAppUrl(namespace);
  const welcomeText = getWelcomeText(namespace);
  const detectMobile = useMobileDetect();

  useEffect(() => {
    let tm: null | ReturnType<typeof setTimeout> = null;
    if (detectMobile.isMobile()) {
      tm = setTimeout(() => {
        let url;
        if (!getApp) return;
        if (detectMobile.isAndroid()) {
          url = apps.google;
        }

        if (detectMobile.isIos()) {
          url = apps.apple;
        }

        if (url) {
          window.location.href = url;
        }
      }, 3000);
    }
    return () => {
      if (tm) clearTimeout(tm);
    };
  }, [detectMobile, getApp, apps]);

  return (
    <S.Layout>
      <NamespaceLogo />
      {(getApp && namespace.symbol === 'ideafit') ? (
        <Flex column align="center" spacing={20}>
          <Text
            size="2.3em"
            color="#090909"
            align="center"
            weight="600"
          >
            Thanks for joining us!
          </Text>
          <S.Title
            color="#090909"
            align="center"
            weight="500"
            lineHeight="1.4em"
          >
            To get started, download Training App
            <br />
            (by GymCloud) and log in using your
            <br />
            new account info.
          </S.Title>
        </Flex>
      ) : (
        <S.Title
          color="#090909"
          align="center"
          weight="500"
          lineHeight="1.4em"
        >
          {welcomeText}
        </S.Title>
      )}

      {(namespace.symbol !== 'ideafit' || getApp) && (
        <S.Links>
          <a href={apps.apple}>
            <img
              width="90.5%"
              src={icons.appStore}
              alt=""
            />
          </a>
          <a href={apps.google}>
            <img
              width="100%"
              src={icons.googlePlay}
              alt=""
            />
          </a>
        </S.Links>
      )}
    </S.Layout>
  );
};

UseApp.defaultProps = {
  getApp: false,
};

export default UseApp;
